import Lenis from 'lenis';
import gsap from 'gsap';
import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { easeInOutCubic, classNames } from './constants';

// Lenis smooth scrolling
export const lenis = new Lenis({
  duration: 1,
});

export const scrollToTargetForce = (targetOrSelector, props = {}) => {
  const docEl = document.documentElement;
  if (docEl.classList.contains(classNames.LENIS_FORCE_SCROLLING)) {
    trace("× scrollToTargetForce blocked", targetOrSelector);
    return false;
  }
  const targetEl = targetOrSelector instanceof HTMLElement ? targetOrSelector : document.querySelector(targetOrSelector);
  if (targetEl) {
    trace("↓↓↓ scrollToTargetForce", targetOrSelector);
    docEl.classList.add(classNames.LENIS_FORCE_SCROLLING);
    const lenisProps = {
      duration: 1.5, 
      offset: 0, 
      easing: easeInOutCubic,
      force: true, 
      lock: true, 
      onComplete: () => {
        trace("↓↓↓ scrollToTargetForce COMPLETE", targetOrSelector);
        docEl.classList.remove(classNames.LENIS_FORCE_SCROLLING);
      },
    }
    lenis.scrollTo(targetEl, { ...lenisProps, ...props });
  } else {
    trace("× scrollToTargetForce target not found", targetOrSelector);
  }
}
export const scrollBackABit = (offset, props = {}) => {
  const lenisProps = {
    duration: .5, 
    offset: 0, 
    easing: easeInOutCubic,
    force: true, 
    lock: true, 
  }
  lenis.scrollTo(window.scrollY - offset, { ...lenisProps, ...props });
}

const MIN_SCROLL_TO_OPEN_URL = 3;
const SCROLL_HEIGHT_OFFSET = 5;
// lenis + gsap ScrollTrigger
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

// handle scroll down / up open URL
lenis.on("virtual-scroll", (e) => {
  if (document.documentElement.classList.contains("as-in-progress") || !document.documentElement.classList.contains("as-show")) {
    return false;
  }
  const { deltaY, deltaX } = e;
  if (deltaY > MIN_SCROLL_TO_OPEN_URL) {
    onScrollDownTo(e);
  } else if (deltaY < -MIN_SCROLL_TO_OPEN_URL) {
    onScrollUpTo(e);
  }
});

// handle scroll DOWN
const onScrollDownTo = (e) => {
  // check scroll down to URL
  const triggerUrl = document.querySelector("[data-scroll-down-to]");
  if (triggerUrl && !triggerUrl.classList.contains("fired")) {
    // check if scrolled to bottom
    if (window.scrollY + window.innerHeight + SCROLL_HEIGHT_OFFSET >= document.body.scrollHeight) {
      triggerUrl.classList.add("fired");
      // triggerUrl.click();
      const url = triggerUrl.getAttribute("href");
      RytmWebflow.aswap.openURL(url);
    }
  }
  // check scroll to ext section
  const triggerScroll = document.querySelector("[data-scroll-down-to-section]");
  if (triggerScroll && !triggerScroll.classList.contains("fired")) {
    // check if trigger is visible
    if (triggerScroll.getBoundingClientRect().top <= window.innerHeight / 2) {
      // triggerScroll.click();
      // triggerScroll.classList.add("fired");
    }
  }
  
}
// handle scroll UP
const onScrollUpTo = (e) => {
  const triggerUrl = document.querySelector("[data-scroll-up-to]");
  if (triggerUrl && !triggerUrl.classList.contains("fired")) {
    // check if scrolled to top
    if (window.scrollY <= SCROLL_HEIGHT_OFFSET) {
      triggerUrl.classList.add("fired");
      // triggerUrl.click();
      const url = triggerUrl.getAttribute("href");
      RytmWebflow.aswap.openURL(url);
    }
  }
}